let rememberLastLink = null;

export default function initAsideNav() {
    const asideNavOverlay = document.querySelector('#aside-nav-overlay');
    const asideNav = document.querySelector('#aside-nav');
    const subNavsPanels = document.querySelectorAll('[data-subnav-panel]');

    if (!asideNavOverlay || !asideNav) {
        return;
    }

    const asideNavToggle = document.querySelectorAll('[data-aside-nav-toggle]');

    asideNavToggle.forEach((subnavLink) => {
        subnavLink.addEventListener('click', (event) => {
            event.preventDefault();

            const isAlreadyActive = subnavLink.classList.contains('is-active');

            const subNavId = subnavLink.getAttribute('data-aside-nav-toggle');

            if (!subNavId || !document.querySelector(`[data-subnav-panel="${subNavId}"]`)) {
                return;
            }

            // Reset
            reset();

            if (isAlreadyActive) {
                return;
            }

            rememberLastLink = event.currentTarget;

            // Activate
            document.querySelector(`[data-subnav-panel="${subNavId}"]`).classList.add('is-active');
            document
                .querySelector(`[data-subnav-panel="${subNavId}"]`)
                .setAttribute('aria-hidden', 'false');

            subnavLink.classList.add('is-active');
            asideNavOverlay.classList.add('is-active');
            asideNav.classList.add('is-active');

            // Remove tabindex="-1" on all subnav links
            const subnavLinks = document.querySelectorAll(`[data-subnav-panel="${subNavId}"] a`);
            subnavLinks.forEach((subnavLink) => {
                subnavLink.removeAttribute('tabindex');
            });

            // Focus first link
            const firstLink = document.querySelector(`[data-subnav-panel="${subNavId}"] a`);
            firstLink.focus();

            // Prevent body from scrolling
            document.body.classList.add('is-fixed');
        });
    });

    const mobileCloseBtn = document.querySelector('.mobile-close');

    if (mobileCloseBtn) {
        mobileCloseBtn.addEventListener('click', () => {
            reset();
            asideNav.classList.remove('show');
        });
    }

    asideNavOverlay.addEventListener('click', () => {
        reset();
        asideNav.classList.remove('show');
    });

    // Escape key
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            reset();
            asideNav.classList.remove('show');
        }
    });

    function reset() {
        asideNavToggle.forEach((subnavLink) => {
            subnavLink.classList.remove('is-active');
        });

        subNavsPanels.forEach((sub) => {
            sub.classList.remove('is-active');
            sub.setAttribute('aria-hidden', 'true');

            // Add tabindex="-1" on all subnav links
            const subnavLinks = sub.querySelectorAll('a');
            subnavLinks.forEach((subnavLink) => {
                subnavLink.setAttribute('tabindex', '-1');
            });
        });

        asideNavOverlay.classList.remove('is-active');
        asideNav.classList.remove('is-active');

        document.body.classList.remove('is-fixed');

        if (rememberLastLink) {
            rememberLastLink.focus();
            rememberLastLink = null;
        }
    }

    const burgerBtn = document.querySelector('.main-nav .burger-btn');

    if (burgerBtn) {
        burgerBtn.addEventListener('click', () => {
            asideNav.classList.add('show');
            asideNavOverlay.classList.add('is-active');
            // Prevent body from scrolling
            document.body.classList.add('is-fixed');
        });
    }

    // Window scroll
    window.addEventListener('scroll', () => {
        if (window.scrollY > 0) {
            document.querySelector('.main-nav').classList.add('is-scrolled');
        } else {
            document.querySelector('.main-nav').classList.remove('is-scrolled');
        }
    });

    const mobileBackBtns = document.querySelectorAll('#aside-nav .mobile-back');
    mobileBackBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
            reset();
            asideNavOverlay.classList.add('is-active');
            // Prevent body from scrolling
            document.body.classList.add('is-fixed');
        });
    });

    // Check is-current and add it to the parent
    const currentSubNav = document.querySelector('.col .link.is-current');

    if (currentSubNav) {
        const slug = currentSubNav.closest('.main-panel').getAttribute('data-subnav-panel');

        if (slug) {
            const parentLink = document.querySelector(
                `.main-links [data-aside-nav-toggle="${slug}"]`
            );

            const parentLinkSecondary = document.querySelector(
                `.secondary-links [data-aside-nav-toggle="${slug}"]`
            );

            if (parentLink) {
                parentLink.classList.add('is-current');
            }

            if (parentLinkSecondary) {
                parentLinkSecondary.classList.add('is-current');
            }
        }
    }

    const bottomExpandLink = document.querySelector('.bottom-expand-links');
    const openBottomExpandLink = document.querySelector('[data-expand-links]');

    const closeBottomExpandLink = function () {
        bottomExpandLink.classList.remove('is-active');
        openBottomExpandLink.setAttribute('aria-expanded', 'false');
        const tabindexElements = bottomExpandLink.querySelectorAll('[tabindex]');
        tabindexElements.forEach((element) => {
            element.setAttribute('tabindex', '-1');
        });
    };

    if (bottomExpandLink) {
        openBottomExpandLink.addEventListener('click', (e) => {
            e.preventDefault();
            bottomExpandLink.classList.toggle('is-active');

            if (bottomExpandLink.classList.contains('is-active')) {
                openBottomExpandLink.setAttribute('aria-expanded', 'true');
                const tabindexElements = bottomExpandLink.querySelectorAll('[tabindex]');
                tabindexElements.forEach((element) => {
                    element.setAttribute('tabindex', '0');
                });
            } else {
                closeBottomExpandLink();
            }
        });

        // Escape key
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                closeBottomExpandLink();
            }
        });

        // On click outside
        document.addEventListener('click', (e) => {
            if (!bottomExpandLink.contains(e.target)) {
                closeBottomExpandLink();
            }
        });
    }

    // Set Proper position
    const wel = document.querySelector('.with-expand-links');
    if (wel) {
        const properHeight = wel.getBoundingClientRect().height;
        bottomExpandLink.style.bottom = `${properHeight - 5}px`;

        window.addEventListener('resize', () => {
            const properHeight = wel.getBoundingClientRect().height;
            bottomExpandLink.style.bottom = `${properHeight - 5}px`;
        });
    }
}
